/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import FormatPrice from "../formatters/FormatPrice";
import T from "../ui/Translation";
import Badge from "../ui/Badge";
import { DISCOUNT_TYPE } from "../../constants/constants";

const DiscountBadge = ({ discount, discountType, currency, ...props }) => {
  if (discount == null) return null;
  const isPercent = discountType === DISCOUNT_TYPE.PERCENTAGE;
  const discountValue = isPercent ? `${discount}%` : <FormatPrice value={discount} currency={currency} />

  return (
    <Badge color="primary" title={<><T>discount</T>{" "}{discountValue}</>} {...props} />
  );
};

export default DiscountBadge;
